import postAPI from './postAPI.js'

export default async function postUnarchiveTaskFlow(id) {
    const data = await postAPI('admin/taskflows/unarchive', { id });
    return data;
}
